import { Grid, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import React from 'react';

// Original class: SettingsBlock
const StyledSettingsBlock = styled(Grid)(theme => ({
  maxWidth: '50%',
}));
// Original class: SettingsFieldsHead
const StyledSettingsFieldsHead = styled(Typography)(theme => ({
  width: '33%',
}));
// Original class: SettingsFields
const StyledSettingsFields = styled(Typography)(theme => ({
  width: '50%',
}));

const SettingsUpperLine = ({ header, content }) => {
  return (
    <StyledSettingsBlock
      item
      container
      direction='row'
      sx={{
        gap: 10,
        marginBottom: 3,
      }}
    >
      <StyledSettingsFieldsHead
        variant='h4'
        xs={2}
        sx={{
          position: 'relative',
          fontWeight: 700,
        }}
      >
        {header}:
      </StyledSettingsFieldsHead>
      <StyledSettingsFields
        variant='h4'
        xs={2}
        sx={{
          position: 'relative',
        }}
      >
        {content}
      </StyledSettingsFields>
    </StyledSettingsBlock>
  );
};

export default SettingsUpperLine;
